<template>
  <div class="loginElement">
    <!-- 自动登录时显示 loading，隐藏表单 -->
    <div v-if="autoLogging" class="auto-login-loading">
      <i class="el-icon-loading"></i>
      <span>正在登录，请稍候...</span>
    </div>
    <template v-else>
      <el-form :model="ruleForm" :rules="rules" label-position="left" ref="ruleForm" label-width="100px">
        <el-form-item label="帐号：" prop="username">
          <el-input  placeholder="请输入帐号"
              onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
              v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item  label="密码：" prop="password">
          <el-input type="password" show-password placeholder="请输入密码"
                    onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                    v-model="ruleForm.password"/>
        </el-form-item>
        <el-form-item label="验证码：" prop="code">
          <div style="display: flex; align-items: center;">
            <el-input type="text"  placeholder="请输入验证码"
                      onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                      v-model="ruleForm.code"></el-input>
            <div class="login-code">
              <img :src="codeUrl"
                   @click="getCode"
                   alt="验证码">
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div style="width: 100%;text-align: center">
        <el-button style="width: 100%;" type="primary" id="btn" @click="login()">登录</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import * as u from "@/utils/util";
import { Decrypt } from "@/utils/util";

// 自动登录信息存储键（使用 sessionStorage，不受 localStorage.clear() 影响）
const AUTO_LOGIN_KEY = "LOCATION_SOURCE";

export default {
  name: "loginElement",
  data(){
    return{
      // 自动登录时显示 loading
      autoLogging: false,
      //登录表单
      ruleForm: { 
        code: '',
        randomStr: u.uuid(),
      },
      //登录校验
      rules: {
        username: [
          {required: true, message: '请输入帐号', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
      },
      //验证码图片url
      codeUrl: "",
    }
  },
  created(){
    // 检测 URL 中是否含有 username 参数（自动登录流程）
    if (window.location.href.indexOf("username") !== -1) {
      this.autoLogging = true;
      try {
        const rawUser = this.getUrlCode("username");
        const rawPass = this.getUrlCode("password");
        const username = Decrypt(decodeURIComponent(rawUser));
        const password = Decrypt(decodeURIComponent(rawPass));
        // 填入表单
        this.ruleForm.username = username;
        this.ruleForm.password = password;
        this.ruleForm.code = '6363';
        this.ruleForm.checkKey = new Date().getTime();
        // 用 history.replaceState 清理 URL 参数，不触发页面刷新也不触发路由变化
        const cleanUrl = window.location.href.split('?')[0];
        window.history.replaceState(null, '', cleanUrl);
        // 先获取验证码（需要 randomStr），完成后直接登录
        this.$nextTick(() => {
          this.getCode().then(() => {
            this.confirmLogin(true);
          });
        });
      } catch(e) {
        console.error('[AutoLogin] 解密失败', e);
        this.getCode();
      }
    } else {
      // 正常访问登录页
      this.getCode();
    }
  },
  mounted(){},
  methods: {
    getUrlCode(key) {
      let results = new RegExp('[?&]' + key + '=([^&#]*)').exec(window.location.href);
      if (results) {
        return results[1];
      } else {
        return '';
      }
    },
    //获取验证码
    getCode() {
      return this.$HttpService.get("/sys-login/getCode", {
        randomStr: this.ruleForm.randomStr,
      }).then(res => {
        this.codeUrl = res;
        this.randomStr = u.uuid();
      })
    },
    // 统一登录执行方法（auto=true 时为自动登录，跳过表单校验）
    confirmLogin(auto) {
      const doLogin = () => {
        this.$HttpService.post("/sys-login/login", this.ruleForm).then(res => {
          // 设置存储用户基本信息
          this.$util.setLoginInfo(res);
          // 设置登录状态到 Vuex store
          this.$store.commit('SET_LOGIN_STATE', true);
          // 检查是否有重定向参数
          const redirect = this.$route.query.redirect;
          // 跳转路由
          setTimeout(() => {
            if (redirect) {
              this.$router.push(redirect);
            } else {
              this.$router.push({ path: "/file/myFileTree" });
            }
          }, 200);
        }).catch(() => {
          this.getCode();
        });
      };

      // auto=true 时为自动登录，直接跳过表单校验执行
      if (auto) {
        this.ruleForm.checkKey = new Date().getTime();
        doLogin();
      } else {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            doLogin();
          }
        });
      }
    },
    // 登录按钮点击
    login() {
      this.confirmLogin();
    }
  }
}
</script>


<style scoped lang="scss">
.loginElement {
  .auto-login-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #409EFF;
    i {
      font-size: 32px;
      animation: rotating 1s linear infinite;
    }
    span {
      margin-top: 12px;
      font-size: 14px;
      color: #666;
    }
  }
  @keyframes rotating {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  .login-code {
    margin-left: 10px;
    cursor: pointer;
    
    img {
      height: 40px;
      border-radius: 4px;
    }
  }

  // ==================== 移动端适配 ====================
  @media screen and (max-width: 768px) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 16px;

        .el-form-item__label {
          font-size: 13px;
          line-height: 38px;
          padding: 0 6px 0 0;
          width: 65px !important;
        }

        .el-form-item__content {
          line-height: 38px;
          margin-left: 65px !important;

          .el-input {
            .el-input__inner {
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              padding: 0 12px;
              border-radius: 5px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 38px;

                .el-icon-view,
                .el-icon-circle-close {
                  font-size: 15px;
                }
              }
            }
          }
        }
      }
    }

    .login-code {
      margin-left: 6px;
      flex-shrink: 0;

      img {
        height: 38px;
        width: 85px;
        border-radius: 5px;
      }
    }

    ::v-deep .el-button {
      height: 38px;
      font-size: 15px;
      border-radius: 5px;
      font-weight: 500;
    }
  }

  // 小屏幕手机适配（宽度小于 480px）
  @media screen and (max-width: 480px) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 14px;

        .el-form-item__label {
          font-size: 13px;
          line-height: 36px;
          width: 60px !important;
        }

        .el-form-item__content {
          line-height: 36px;
          margin-left: 60px !important;

          .el-input {
            .el-input__inner {
              height: 36px;
              line-height: 36px;
              font-size: 14px;
              padding: 0 10px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 36px;
              }
            }
          }
        }
      }
    }

    .login-code {
      margin-left: 6px;

      img {
        height: 36px;
        width: 80px;
      }
    }

    ::v-deep .el-button {
      height: 36px;
      font-size: 14px;
    }
  }

  // 横屏模式适配
  @media screen and (max-width: 768px) and (orientation: landscape) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
          line-height: 34px;
        }

        .el-form-item__content {
          line-height: 34px;

          .el-input {
            .el-input__inner {
              height: 34px;
              line-height: 34px;
              font-size: 13px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 34px;
              }
            }
          }
        }
      }
    }

    .login-code {
      img {
        height: 34px;
        width: 75px;
      }
    }

    ::v-deep .el-button {
      height: 34px;
      font-size: 13px;
    }
  }
}
</style>
